import fordCatalogue from './fordCatalogue';

export const catalogue = fordCatalogue.vehicles;
export const families = fordCatalogue.families;
export const catalogueSource = { ...fordCatalogue.sources['transit-custom'], checkedAt: fordCatalogue.checkedAt };
export const catalogueVersion = fordCatalogue.version;

export const TERMS = {
  rental: [
    { value: 'daily', label: 'Daily rental' },
    { value: 'weekly', label: 'Weekly rental' },
    { value: '28-days', label: '28-day rental' },
  ],
  hire: [
    { value: '3-months', label: '3-month agreement' },
    { value: '6-months', label: '6-month agreement' },
    { value: '9-months', label: '9-month agreement' },
    { value: '12-months', label: '12-month agreement' },
  ],
};

export const getFamily = id => families.find(family => family.id === id);

export function getVehicle(idOrSlug, family) {
  return catalogue.find(vehicle => vehicle.id === idOrSlug && (!family || vehicle.family === family))
    || catalogue.find(vehicle => vehicle.slug === idOrSlug && vehicle.family === (family || 'transit-custom'));
}

export function getServiceSelection(selection = {}) {
  const service = selection.service === 'hire' ? 'hire' : 'rental';
  const term = TERMS[service].some(item => item.value === selection.term)
    ? selection.term : TERMS[service][0].value;
  return { service, term };
}

export function getValidSelection(vehicle, selection = {}) {
  const serviceSelection = getServiceSelection(selection);
  if (!vehicle) return serviceSelection;
  const lengths = [...new Set(vehicle.configurations.map(item => item.length))];
  const length = lengths.includes(selection.length) ? selection.length : lengths[0];
  const atLength = vehicle.configurations.filter(item => item.length === length);
  const roofs = [...new Set(atLength.map(item => item.roof))];
  const roof = roofs.includes(selection.roof) ? selection.roof : roofs[0];
  const configurations = atLength.filter(item => item.roof === roof);
  const preferredTrim = configurations.some(item => item.trim === 'Limited') ? 'Limited' : configurations[0].trim;
  const trim = configurations.some(item => item.trim === selection.trim) ? selection.trim : preferredTrim;
  return { ...serviceSelection, length, roof, trim };
}

export function getQuoteUrl(vehicle, selection = {}) {
  const resolved = typeof vehicle === 'string' ? getVehicle(vehicle) : vehicle;
  const params = new URLSearchParams();
  if (resolved) params.set('vehicle', resolved.id);
  Object.entries(getValidSelection(resolved, selection)).forEach(([key, value]) => params.set(key, value));
  return `/request-a-quote?${params.toString()}`;
}

export function getVehiclePath(vehicle, selection = {}) {
  return `/our-vans/ford/${vehicle.family}/${vehicle.slug}?${new URLSearchParams(getValidSelection(vehicle, selection))}`;
}

export function filterVehicles(filters = {}, vehicles = catalogue) {
  return vehicles.filter(vehicle => (
    (!filters.family || vehicle.family === filters.family)
    && (!filters.body || vehicle.body === filters.body)
    && (!filters.powertrain || vehicle.powertrain === filters.powertrain
      || (filters.powertrain === 'electrified' && ['electric', 'phev'].includes(vehicle.powertrain)))
    && vehicle.configurations.some(configuration => (
      (!filters.length || configuration.length === filters.length)
      && (!filters.roof || configuration.roof === filters.roof)
      && (!filters.trim || configuration.trim === filters.trim)
      && (!filters.transmission || configuration.options.some(option => option.transmission.toLowerCase().includes(filters.transmission.toLowerCase())))
    ))
  ));
}

export function getVehicleSpecs(vehicle, selection) {
  const specs = vehicle.specsByConfiguration?.[`${selection.length}-${selection.roof}`]
    || vehicle.specsByLength?.[selection.length] || {};
  return { ...specs, overallLengthMm: specs.overallLengthByTrimMm?.[selection.trim] ?? specs.overallLengthMm };
}

export function getLengthLabel(length, vehicle) {
  if (vehicle?.family === 'transit-custom') return ({ L1: 'L1 · Short wheelbase', L2: 'L2 · Long wheelbase' })[length] || length;
  return length === 'Standard' ? 'Standard length' : length;
}
export function getRoofLabel(roof) { return roof === 'Standard' ? 'Standard roof' : `${roof} roof`; }
export const LENGTH_LABELS = { L1: 'L1', L2: 'L2', L3: 'L3', L4: 'L4', L5: 'L5', Standard: 'Standard length' };
export const BODY_LABELS = { panel: 'Panel van', crew: 'Double Cab-in-Van', multicab: 'MultiCab', flexcab: 'FlexCab', 'single-cab': 'Single cab', 'double-cab': 'Double cab', 'single-cab-toolpod': 'Single cab with toolpod' };
export const POWERTRAIN_LABELS = { diesel: 'Diesel', petrol: 'Petrol', phev: 'Plug-in hybrid', electric: 'Fully electric' };

export function getVehicleLabel(vehicle) {
  const body = vehicle.name.toLowerCase().includes(vehicle.bodyLabel.toLowerCase()) ? [] : [vehicle.bodyLabel];
  return [vehicle.name, ...body, vehicle.powertrainLabel].join(' · ');
}
